import { render } from "./PolicyEdit.vue?vue&type=template&id=737f5738"
import script from "./PolicyEdit.vue?vue&type=script&lang=js"
export * from "./PolicyEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__